<template>
  <section class="bg-green-500" :style="`background: #26a3a7 url('${myResBaseUrl}atis-assets/background/04.png') no-repeat center center / cover;`">
  
    
  <div class="flex w-full">
    <div class="w-1/3 flex">
      <div class="w-1/3 py-1 bg-green-700"></div>
      <div class="w-1/3 py-1 bg-green-800"></div>
      <div class="w-1/3 py-1 bg-green-900"></div>
    </div>
    <div class="w-1/3 flex">
      <div class="w-1/3 py-1 bg-green-700"></div>
      <div class="w-1/3 py-1 bg-green-800"></div>
      <div class="w-1/3 py-1 bg-green-900"></div>
    </div>
    <div class="w-1/3 flex">
      <div class="w-1/3 py-1 bg-green-700"></div>
      <div class="w-1/3 py-1 bg-green-800"></div>
      <div class="w-1/3 py-1 bg-green-900"></div>
    </div>
  </div>
  
  <div class="container mx-auto px-4 hidden">
    <div class="pt-10 pb-12">
      <div class="flex flex-wrap -mx-4">
        <div class="mb-4 w-full lg:w-1/4 px-4" v-for="(o,i) in list" :key="i">
          <div class="flex px-2 py-2 bg-white shadow rounded">
            <img :src="`logos/${o.id}.png`" class="grayscale hover:grayscale-0 rounded wd-60 mr-3" alt />
            <h4 class="mb-2">{{o.name}}</h4>
          </div>
        </div>
      </div>
      <div class="relative lg:pb-8 mb-8 flex flex-wrap lg:border-b lg:border-gray-300">
        <p class="w-full lg:w-auto text-gray-400 text-sm text-center lg:text-left order-last lg:order-first">© 2022. GoSmart TM.</p>
        <div class="lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2 mb-6 lg:mb-0 mx-auto">
          <a class="inline-block text-xl font-bold leading-none" href="#">
            <img class="inline-block h-30 lg:h-16" :src="`${myResBaseUrl}media/logo/gosmart-16.png`" alt="" width="auto">
          </a>
        </div>
        <div class="mb-12 lg:mb-0 lg:ml-auto w-full lg:w-auto order-first lg:order-last text-center lg:text-left">
          <a class="mr-6 text-sm hover:text-gray-500" href="#">Компани</a>
          <a class="text-sm hover:text-gray-500" href="#">Холбоо барих</a>
          
        </div>
      </div>
      <div class="flex justify-center">
        <a class="inline-block w-10 mr-2 p-2 bg-white hover:bg-gray-50 rounded" href="#">
          <img class="mx-auto" :src="`${myResBaseUrl}atis-assets/social/facebook.svg`">
        </a>
        <a class="inline-block w-10 mr-2 p-2 bg-white hover:bg-gray-50 rounded" href="#">
          <img class="mx-auto" :src="`${myResBaseUrl}atis-assets/social/twitter.svg`">
        </a>
        <a class="inline-block w-10 p-2 bg-white hover:bg-gray-50 rounded" href="#">
          <img class="mx-auto" :src="`${myResBaseUrl}atis-assets/social/instagram.svg`">
        </a>
      </div>
    </div>
  </div>

  <div class="container mx-auto px-4">
    <div class="pt-10 pb-12">

      <div class="flex flex-wrap">
        <div class="mb-8 w-full lg:w-1/5 px-3" v-for="(o,i) in list" :key="i">
          <h3 class="line-clamp-1 text-sm text-white font-bolder font-heading text-truncate">{{o.name}}</h3>
          <div class="flex flex-wrap items-center mt-2">
            <img :src="`logos/${o.id}.png`" class="grayscale hover:grayscale-0 rounded wd-20" style="filter: grayscale(100%);" alt />
            <div class="text-gray-300 ml-1">
              {{o.domain}}
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="flex flex-wrap -mx-4">
        <div class="mb-4 w-full lg:w-1/4 px-4" v-for="(o,i) in list" :key="i">
          <div class="flex px-2 py-2 text-white">
            <img :src="`logos/${o.id}.png`" class="grayscale hover:grayscale-0 rounded wd-60 mr-3" alt />
            <h4 class="mb-2 text-white">{{o.name}}</h4>
          </div>
        </div>
      </div> -->
      <div class="relative lg:pb-8 mb-8 flex flex-wrap border-t border-green-700 pt-2">
        <p class="w-full lg:w-auto text-white text-sm text-center lg:text-left order-last lg:order-first">© 2022. GoSmart TM.</p>
        <div class="lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2 mb-6 lg:mb-0 mx-auto">
          <a class="inline-block text-xl font-bold leading-none " href="#">
            <img class="inline-block h-30 lg:h-24" :src="`${myResBaseUrl}media/logo/gosmart-16.png`" alt="" width="auto">
          </a>
        </div>
        <div class="text-white mb-12 lg:mb-0 lg:ml-auto w-full lg:w-auto order-first lg:order-last text-center lg:text-left">
          <a class="mr-6 text-sm hover:text-gray-500" href="#">Компани</a>
          <a class="text-sm hover:text-gray-500" href="#">Холбоо барих</a>
          
        </div>
      </div>
      <div class="flex justify-center mt-20">
        <a class="inline-block w-10 mr-2 p-2 bg-white hover:bg-gray-50 rounded" href="#">
          <img class="mx-auto" :src="`${myResBaseUrl}atis-assets/social/facebook.svg`">
        </a>
        <a class="inline-block w-10 mr-2 p-2 bg-white hover:bg-gray-50 rounded" href="#">
          <img class="mx-auto" :src="`${myResBaseUrl}atis-assets/social/twitter.svg`">
        </a>
        <a class="inline-block w-10 p-2 bg-white hover:bg-gray-50 rounded" href="#">
          <img class="mx-auto" :src="`${myResBaseUrl}atis-assets/social/instagram.svg`">
        </a>
      </div>
    </div>
  </div>

</section>
</template>

<script>
import { request } from "@/api/all";

export default {
  data(){
    return{
      myResBaseUrl: "https://res.gosmart.mn/",
      list: []
    }
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {

    this.init();
  },
  methods:{
    init(){
      request({
        api: { method: "GET", url: "activeKeys" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //this.handleLoading({ isLoading: false });
          this.list = res.data.list;
        }
      });
    }
  }
}
</script>

<style>

</style>